export default class Boundable {
  getBounds() {}
}
